(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var btn = document.querySelector('.back-to-top');
    if (!btn) return;
    var threshold = function () { return Math.max(window.innerHeight * 0.6, 400); };
    var onScroll = function () {
      if (window.scrollY > threshold()) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    onScroll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rpp-freeform"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rpz2Init) return;
    window.__rpz2Init = true;

    var controls = document.querySelector('.pz2__controls');
    var preview = document.querySelector('.pz2__preview');
    if (!controls || !preview) return;
    var stage = preview.querySelector('.pz2__stage');
    var layersBox = controls.querySelector('.pz2__layers');
    var fileInput = controls.querySelector('.pz2__file');
    var SVGNS = 'http://www.w3.org/2000/svg';
    var UPLOAD_ENDPOINT = 'https://reishore-personalizer-upload.reishore.workers.dev';

    // ── Garment from product handle/title ──
    var GARMENTS = [
      ['bottoms', /bottom|pant|jogger|short/],
      ['hoodie', /hoodie|hooded/],
      ['crew', /crewneck|sweatshirt/],
      ['jacket', /jacket|windbreaker|coach/],
      ['polo', /polo/],
      ['tank', /tank|basketball/],
      ['tq', /3.?4|three.?quarter|raglan/],
      ['ls', /long.?sleeve/],
      ['tee', /./]
    ];
    var blob = (controls.dataset.handle + ' ' + controls.dataset.title).toLowerCase();
    var G = 'tee';
    for (var gi = 0; gi < GARMENTS.length; gi++) {
      if (GARMENTS[gi][1].test(blob)) { G = GARMENTS[gi][0]; break; }
    }
    // symbols reused across garments; clip follows the silhouette actually used
    var CLIP = { tee: 'tee', ls: 'ls', tq: 'tq', tank: 'tank', crew: 'ls', hoodie: 'hoodie', polo: 'tee', jacket: 'ls', bottoms: 'bottoms' }[G];
    preview.querySelectorAll('.pz2__garment, .pz2__thumb-use').forEach(function (u) {
      u.setAttribute('href', '#pz2-g-' + G + '-' + (u.dataset.view === 'front' ? 'f' : 'b'));
    });
    preview.querySelectorAll('.pz2__areas').forEach(function (g) {
      g.setAttribute('clip-path', 'url(#pz2-clip-' + CLIP + ')');
    });

    // Full garment bounding box (incl. sleeves/hood) — new art covers this by
    // default; the silhouette clip crops the overflow for a true all-over look.
    var BOUNDS = {
      tee:     { x: 133, y: 148, w: 374, h: 389 },
      polo:    { x: 133, y: 148, w: 374, h: 389 },
      tq:      { x: 129, y: 148, w: 382, h: 389 },
      tank:    { x: 215, y: 146, w: 210, h: 391 },
      ls:      { x: 118, y: 148, w: 404, h: 389 },
      crew:    { x: 118, y: 148, w: 404, h: 389 },
      jacket:  { x: 118, y: 116, w: 404, h: 421 },
      hoodie:  { x: 118, y: 88,  w: 404, h: 449 },
      bottoms: { x: 228, y: 150, w: 184, h: 386 }
    }[G];

    var hexMap = {};
    try {
      hexMap = JSON.parse(document.querySelector('.rpp__data').textContent).colorHexMap || {};
    } catch (e) {}

    // ── State ──
    var layers = [];       // {id,name,url,file,dims,remoteUrl,view,cx,cy,w,h}
    var nextId = 1;
    var selectedId = null;
    var view = 'front';

    // Exposed for host forms without #rpp-customily-form (e.g. the sports
    // uniform builder reads this when building its quote note).
    window.RPZ2 = { layers: layers, thumbUrl: null };

    var areaEls = {
      front: preview.querySelector('.pz2__areas[data-view="front"]'),
      back: preview.querySelector('.pz2__areas[data-view="back"]')
    };
    var uiEls = {
      front: preview.querySelector('.pz2__ui-layer[data-view="front"]'),
      back: preview.querySelector('.pz2__ui-layer[data-view="back"]')
    };
    var tabs = preview.querySelectorAll('.pz2__tab');

    function setView(v) {
      view = v;
      preview.querySelectorAll('.pz2__garment, .pz2__areas, .pz2__ui-layer').forEach(function (el) {
        el.style.display = el.dataset.view === v ? '' : 'none';
      });
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.view === v); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { setView(t.dataset.view); }); });

    // ── Compositor ──
    function redraw() {
      areaEls.front.innerHTML = '';
      areaEls.back.innerHTML = '';
      uiEls.front.innerHTML = '';
      uiEls.back.innerHTML = '';
      layers.forEach(function (L) {
        var img = document.createElementNS(SVGNS, 'image');
        img.setAttribute('href', L.url);
        img.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        img.setAttribute('x', L.cx - L.w / 2);
        img.setAttribute('y', L.cy - L.h / 2);
        img.setAttribute('width', L.w);
        img.setAttribute('height', L.h);
        img.setAttribute('class', 'pz2__img');
        img.setAttribute('data-id', L.id);
        areaEls[L.view].appendChild(img);
        if (L.id === selectedId) {
          // UI lives on an unclipped layer so the handle stays visible even
          // when the art bleeds past the garment edge.
          var ol = document.createElementNS(SVGNS, 'rect');
          ol.setAttribute('class', 'pz2__ui pz2__outline');
          ol.setAttribute('x', L.cx - L.w / 2);
          ol.setAttribute('y', L.cy - L.h / 2);
          ol.setAttribute('width', L.w);
          ol.setAttribute('height', L.h);
          uiEls[L.view].appendChild(ol);
          var hd = document.createElementNS(SVGNS, 'circle');
          hd.setAttribute('class', 'pz2__ui pz2__handle');
          hd.setAttribute('data-id', L.id);
          hd.setAttribute('cx', L.cx + L.w / 2);
          hd.setAttribute('cy', L.cy + L.h / 2);
          hd.setAttribute('r', '12');
          uiEls[L.view].appendChild(hd);
        }
      });
      preview.hidden = !layers.length;
      syncFloat();
      renderList();
    }

    function renderList() {
      layersBox.innerHTML = '';
      layers.forEach(function (L, i) {
        var row = document.createElement('div');
        row.className = 'pz2__layer' + (L.id === selectedId ? ' is-selected' : '');
        row.dataset.id = L.id;
        row.innerHTML =
          '<img class="pz2__layer-thumb" src="' + L.url + '" alt="">' +
          '<span class="pz2__layer-name">Design ' + (i + 1) + ' — ' + L.name.replace(/</g, '&lt;') + '</span>' +
          '<span class="pz2__layer-view">' + (L.view === 'front' ? 'Front' : 'Back') + '</span>' +
          '<button type="button" class="pz2__layer-remove">Remove ✕</button>';
        layersBox.appendChild(row);
      });
    }

    // ── Quote/cart properties ──
    function syncProps() {
      var form = document.getElementById('rpp-customily-form');
      if (!form) return;
      form.querySelectorAll('input[data-pz2-prop]').forEach(function (i) { i.remove(); });
      layers.forEach(function (L, i) {
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.setAttribute('data-pz2-prop', L.id);
        inp.name = 'properties[Artwork — Design ' + (i + 1) + ' (' + (L.view === 'front' ? 'Front' : 'Back') + ')]';
        inp.value = (L.remoteUrl || (L.file.name + ' (not uploaded — request file from customer)')) + ' | all-over placement, customer-arranged (estimate)';
        form.appendChild(inp);
      });
    }

    // ── Upload processing (white-background strip, same as regular flow) ──
    function cornersWhite(p, w, h) {
      var pts = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
      var n = 0;
      for (var i = 0; i < 4; i++) {
        var o = pts[i];
        if (p[o + 3] === 0 || (p[o] >= 235 && p[o + 1] >= 235 && p[o + 2] >= 235)) n++;
      }
      return n >= 3;
    }
    function processFile(file, cb) {
      if (file.type === 'image/svg+xml' || /\.svg$/i.test(file.name)) {
        cb(URL.createObjectURL(file), null);
        return;
      }
      var src = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var W = img.naturalWidth, H = img.naturalHeight, MAX = 1600;
        var s = Math.min(1, MAX / Math.max(W, H));
        var cw = Math.max(1, Math.round(W * s)), ch = Math.max(1, Math.round(H * s));
        var c = document.createElement('canvas');
        c.width = cw;
        c.height = ch;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, cw, ch);
        try {
          var d = x.getImageData(0, 0, cw, ch), p = d.data;
          if (cornersWhite(p, cw, ch)) {
            for (var i = 0; i < p.length; i += 4) {
              var m = Math.min(p[i], p[i + 1], p[i + 2]);
              if (m >= 242) p[i + 3] = 0;
              else if (m >= 230) p[i + 3] = Math.min(p[i + 3], (242 - m) * 21);
            }
            x.putImageData(d, 0, 0);
          }
        } catch (err) {}
        URL.revokeObjectURL(src);
        c.toBlob(function (b) { cb(URL.createObjectURL(b || file), { w: W, h: H }); }, 'image/png');
      };
      img.onerror = function () {
        URL.revokeObjectURL(src);
        cb(URL.createObjectURL(file), null);
      };
      img.src = src;
    }
    function uploadRemote(L) {
      if (!UPLOAD_ENDPOINT) return;
      var fd = new FormData();
      fd.append('file', L.file, L.file.name);
      fetch(UPLOAD_ENDPOINT, { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j.url) { L.remoteUrl = j.url; syncProps(); } })
        .catch(function () {});
    }

    function addFiles(files) {
      Array.prototype.slice.call(files).forEach(function (file, idx) {
        processFile(file, function (url, dims) {
          // Cover the whole garment by default (clip crops the overflow)
          var aspect = dims ? dims.w / dims.h : 1;
          var w = BOUNDS.w;
          var h = w / aspect;
          if (h < BOUNDS.h) { h = BOUNDS.h; w = h * aspect; }
          var L = {
            id: nextId++,
            name: file.name,
            url: url,
            file: file,
            dims: dims,
            remoteUrl: null,
            view: view,
            cx: BOUNDS.x + BOUNDS.w / 2,
            cy: BOUNDS.y + BOUNDS.h / 2,
            w: w,
            h: h
          };
          layers.push(L);
          selectedId = L.id;
          syncProps();
          uploadRemote(L);
          redraw();
          queueThumb();
        });
      });
    }

    controls.querySelector('.pz2__upload-btn').addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () {
      addFiles(fileInput.files);
      fileInput.value = '';
    });

    layersBox.addEventListener('click', function (e) {
      var row = e.target.closest('.pz2__layer');
      if (!row) return;
      var id = parseInt(row.dataset.id, 10);
      if (e.target.closest('.pz2__layer-remove')) {
        var idx = layers.findIndex(function (L) { return L.id === id; });
        if (idx > -1) {
          URL.revokeObjectURL(layers[idx].url);
          layers.splice(idx, 1);
        }
        if (selectedId === id) selectedId = null;
        syncProps();
        redraw();
        queueThumb();
        return;
      }
      selectedId = id;
      var L = layers.find(function (x) { return x.id === id; });
      if (L) setView(L.view);
      redraw();
    });

    // ── Drag to move / resize ──
    function svgPoint(e) {
      var pt = stage.createSVGPoint();
      pt.x = e.clientX; pt.y = e.clientY;
      return pt.matrixTransform(stage.getScreenCTM().inverse());
    }
    var drag = null;
    stage.addEventListener('pointerdown', function (e) {
      var h = e.target.closest('.pz2__handle');
      var im = e.target.closest('.pz2__img');
      if (h) {
        var L1 = layers.find(function (x) { return x.id === parseInt(h.dataset.id, 10); });
        if (!L1) return;
        e.preventDefault();
        drag = { mode: 'resize', L: L1 };
        stage.setPointerCapture(e.pointerId);
      } else if (im) {
        var L2 = layers.find(function (x) { return x.id === parseInt(im.dataset.id, 10); });
        if (!L2) return;
        e.preventDefault();
        if (selectedId !== L2.id) { selectedId = L2.id; redraw(); }
        var p = svgPoint(e);
        drag = { mode: 'move', L: L2, dx: p.x - L2.cx, dy: p.y - L2.cy };
        stage.setPointerCapture(e.pointerId);
      } else if (selectedId !== null) {
        selectedId = null;
        redraw();
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var p = svgPoint(e);
      var L = drag.L;
      if (drag.mode === 'move') {
        L.cx = Math.min(640, Math.max(0, p.x - drag.dx));
        L.cy = Math.min(640, Math.max(0, p.y - drag.dy));
      } else {
        // locked-aspect diagonal resize around the layer centre
        var dist = Math.sqrt(Math.pow(p.x - L.cx, 2) + Math.pow(p.y - L.cy, 2));
        var halfDiag = Math.sqrt(L.w * L.w + L.h * L.h) / 2;
        if (halfDiag < 1) return;
        var f = dist / halfDiag;
        var nw = Math.min(BOUNDS.w * 1.6, Math.max(24, L.w * f));
        L.h = L.h * (nw / L.w);
        L.w = nw;
      }
      redraw();
    });
    function endDrag() {
      if (!drag) return;
      drag = null;
      queueThumb();
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    // ── Design-preview thumbnail via the upload Worker ──
    var thumbTimer = null, lastThumbSig = '';
    function setThumbProp(url) {
      window.RPZ2.thumbUrl = url || null;
      var form = document.getElementById('rpp-customily-form');
      if (!form) return;
      var inp = form.querySelector('input[data-pz2-thumb]');
      if (!url) { if (inp) inp.remove(); return; }
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.setAttribute('data-pz2-thumb', '1');
        inp.name = 'properties[Design Preview]';
        form.appendChild(inp);
      }
      inp.value = url;
    }
    function queueThumb() {
      if (!UPLOAD_ENDPOINT) return;
      clearTimeout(thumbTimer);
      thumbTimer = setTimeout(makeThumb, 2500);
    }
    function makeThumb() {
      if (!layers.length) { lastThumbSig = ''; setThumbProp(null); return; }
      var fill = stage.style.getPropertyValue('--pz-fill') || '#d9d9d9';
      var sig = layers.map(function (L) { return L.id + ':' + L.url + '@' + [L.view, L.cx | 0, L.cy | 0, L.w | 0].join(','); }).join('|') + '|' + fill;
      if (sig === lastThumbSig) return;
      lastThumbSig = sig;
      Promise.all(layers.map(function (L) {
        return fetch(L.url).then(function (r) { return r.blob(); }).then(function (b) {
          return new Promise(function (res) {
            var fr = new FileReader();
            fr.onload = function () { res([L.url, fr.result]); };
            fr.readAsDataURL(b);
          });
        });
      })).then(function (pairs) {
        var clone = stage.cloneNode(true);
        clone.querySelectorAll('.pz2__ui').forEach(function (el) { el.remove(); });
        var defs = document.createElementNS(SVGNS, 'defs');
        defs.innerHTML = document.querySelector('.pz2__defs defs').innerHTML;
        clone.insertBefore(defs, clone.firstChild);
        clone.style.cssText = '--pz-fill:' + fill;
        var xml = new XMLSerializer().serializeToString(clone);
        pairs.forEach(function (p) { xml = xml.split(p[0]).join(p[1]); });
        var img = new Image();
        img.onload = function () {
          var c = document.createElement('canvas');
          c.width = 640;
          c.height = 640;
          var x = c.getContext('2d');
          x.fillStyle = '#ffffff';
          x.fillRect(0, 0, 640, 640);
          x.drawImage(img, 0, 0, 640, 640);
          c.toBlob(function (b) {
            if (!b) return;
            var fd = new FormData();
            fd.append('file', b, 'design-preview.png');
            fetch(UPLOAD_ENDPOINT, { method: 'POST', body: fd })
              .then(function (r) { return r.json(); })
              .then(function (j) { if (j.url) setThumbProp(j.url); })
              .catch(function () {});
          }, 'image/png');
        };
        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
      });
    }

    // ── Garment tint from Step 1 color buttons (if the product has colors) ──
    function applyColor(name) {
      var hex = hexMap[name] || '#e9e9e9';
      stage.style.setProperty('--pz-fill', hex);
      preview.style.setProperty('--pz-fill', hex);
      queueThumb();
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.rbo__color-btn');
      if (b) applyColor(b.dataset.color);
    });
    var active = document.querySelector('.rbo__color-btn.is-active');
    if (active) applyColor(active.dataset.color);

    // ── Mobile floating mini-preview ──
    var mobileMQ = window.matchMedia('(max-width: 899px)');
    var galleryBox = document.querySelector('.rpp__gallery') || preview.parentElement;
    var galleryVisible = true;
    function syncFloat() {
      preview.classList.toggle('is-float', mobileMQ.matches && !galleryVisible && !preview.hidden);
    }
    if ('IntersectionObserver' in window && galleryBox) {
      new IntersectionObserver(function (entries) {
        galleryVisible = entries[0].isIntersecting;
        syncFloat();
      }, { threshold: 0.05 }).observe(galleryBox);
    }
    mobileMQ.addEventListener ? mobileMQ.addEventListener('change', syncFloat) : mobileMQ.addListener(syncFloat);

    setView('front');
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rpp-personalizer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rpzInit) return;
    window.__rpzInit = true;

    var root = document.querySelector('.pz__groups');
    var preview = document.querySelector('.pz__preview');
    if (!root || !preview) return;
    var stage = preview.querySelector('.pz__stage');
    var SVGNS = 'http://www.w3.org/2000/svg';

    // Print-area config — short-sleeve tee. Coordinates in template units
    // (viewBox 640x640, ~10.9 units = 1 inch on a 22"-wide body);
    // "in" = max physical print size in inches (drives the DPI check).
    var CFG = {
      groups: [
        ['Front', ['left-chest', 'center-chest', 'full-front', 'oversize-front']],
        ['Back', ['back-collar', 'upper-back', 'full-back']],
        ['Sleeves', ['left-sleeve', 'right-sleeve']]
      ],
      areas: {
        'left-chest':     { label: 'Left Chest',     view: 'front', x: 356, y: 215, w: 46,  h: 46,  in: [5, 5] },
        'center-chest':   { label: 'Center Chest',   view: 'front', x: 268, y: 215, w: 104, h: 83,  in: [10, 8] },
        'full-front':     { label: 'Full Front',     view: 'front', x: 252, y: 215, w: 135, h: 166, in: [13, 16] },
        'oversize-front': { label: 'Oversize Front', view: 'front', x: 235, y: 215, w: 170, h: 212, in: [16, 20] },
        'back-collar':    { label: 'Back Collar',    view: 'back',  x: 304, y: 182, w: 31,  h: 31,  in: [3, 3] },
        'upper-back':     { label: 'Upper Back',     view: 'back',  x: 252, y: 190, w: 135, h: 62,  in: [13, 6] },
        'full-back':      { label: 'Full Back',      view: 'back',  x: 252, y: 181, w: 135, h: 156, in: [13, 15] },
        'left-sleeve':    { label: 'Left Sleeve',    view: 'front', x: 461, y: 260, w: 34,  h: 34,  in: [4, 4], rot: -34 },
        'right-sleeve':   { label: 'Right Sleeve',   view: 'front', x: 145, y: 260, w: 34,  h: 34,  in: [4, 4], rot: 34 }
      }
    };

    // Cloudflare Worker upload endpoint (phase 5). Empty string = uploads
    // stay local-only and cart props carry the filename instead of a URL.
    var UPLOAD_ENDPOINT = 'https://reishore-personalizer-upload.reishore.workers.dev';

    var hexMap = {};
    try {
      hexMap = JSON.parse(document.querySelector('.rpp__data').textContent).colorHexMap || {};
    } catch (e) {}

    // Processed artwork per placement — phase 5/6 reads this for upload + cart props.
    window.RPZ = { art: {} };

    // ── Build tiles ──
    CFG.groups.forEach(function (g) {
      var head = document.createElement('div');
      head.className = 'rbo__cust-section';
      head.textContent = g[0];
      root.appendChild(head);
      var grid = document.createElement('div');
      grid.className = 'pz__grid';
      g[1].forEach(function (key) {
        var a = CFG.areas[key];
        var cell = document.createElement('div');
        cell.className = 'pz__cell';
        cell.dataset.key = key;
        cell.innerHTML =
          '<label class="pz__tile">' +
            '<input type="checkbox" name="rbo-location" value="' + a.label + '">' +
            '<span class="pz__tile-label">Add ' + a.label.toLowerCase() + '</span>' +
            '<span class="pz__tile-box"></span>' +
          '</label>' +
          '<div class="pz__panel" hidden>' +
            '<button type="button" class="pz__upload-btn">Upload Image</button>' +
            '<input type="file" accept=".png,.jpg,.jpeg,.svg,.webp,image/png,image/jpeg,image/svg+xml,image/webp" hidden>' +
            '<div class="pz__thumb-row" hidden><img class="pz__thumb" alt="Artwork preview"><button type="button" class="pz__remove">Remove ✕</button></div>' +
            '<div class="pz__size" hidden>' +
              '<span class="pz__size-label">Print size <span class="pz__size-val">100%</span></span>' +
              '<span class="pz__size-hint">Drag the corner handle on the preview to resize</span>' +
            '</div>' +
            '<p class="pz__warn" hidden></p>' +
          '</div>';
        grid.appendChild(cell);
      });
      root.appendChild(grid);
    });

    // ── View switching ──
    var tabs = preview.querySelectorAll('.pz__tab');
    function setView(v) {
      preview.querySelectorAll('.pz__garment, .pz__areas').forEach(function (el) {
        el.style.display = el.dataset.view === v ? '' : 'none';
      });
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.view === v); });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { setView(t.dataset.view); });
    });

    // ── Preview compositor ──
    var layers = {
      front: preview.querySelector('.pz__areas[data-view="front"]'),
      back: preview.querySelector('.pz__areas[data-view="back"]')
    };
    function redraw() {
      layers.front.innerHTML = '';
      layers.back.innerHTML = '';
      var any = false;
      Object.keys(CFG.areas).forEach(function (key) {
        var cell = root.querySelector('.pz__cell[data-key="' + key + '"]');
        if (!cell || !cell.querySelector('input[type="checkbox"]').checked) return;
        any = true;
        var a = CFG.areas[key];
        var art = window.RPZ.art[key];
        var cx = a.x + a.w / 2, cy = a.y + a.h / 2;
        if (art) {
          // Locked-aspect print box: art fills the placement by default (max
          // fit), scaled by the drag handle, always centered.
          var fit = fitDims(key);
          var s = art.scale || 1;
          var bw = fit.w * s, bh = fit.h * s;
          var bx = cx - bw / 2, by = cy - bh / 2;
          var g = document.createElementNS(SVGNS, 'g');
          if (a.rot) g.setAttribute('transform', 'rotate(' + a.rot + ' ' + cx + ' ' + cy + ')');
          var img = document.createElementNS(SVGNS, 'image');
          img.setAttribute('href', art.url);
          img.setAttribute('preserveAspectRatio', 'xMidYMid meet');
          img.setAttribute('x', bx); img.setAttribute('y', by);
          img.setAttribute('width', bw); img.setAttribute('height', bh);
          g.appendChild(img);
          // Selection outline + corner drag handle (stripped from thumbnails)
          var ol = document.createElementNS(SVGNS, 'rect');
          ol.setAttribute('class', 'pz__ui pz__outline');
          ol.setAttribute('x', bx); ol.setAttribute('y', by);
          ol.setAttribute('width', bw); ol.setAttribute('height', bh);
          g.appendChild(ol);
          var hd = document.createElementNS(SVGNS, 'circle');
          hd.setAttribute('class', 'pz__ui pz__handle');
          hd.setAttribute('data-key', key);
          hd.setAttribute('cx', bx + bw); hd.setAttribute('cy', by + bh);
          hd.setAttribute('r', '11');
          g.appendChild(hd);
          layers[a.view].appendChild(g);
        } else {
          var node = document.createElementNS(SVGNS, 'rect');
          node.setAttribute('rx', '6');
          node.setAttribute('fill', 'url(#pz-hatch)');
          node.setAttribute('fill-opacity', '.3');
          node.setAttribute('stroke', '#F4E026');
          node.setAttribute('stroke-width', '3');
          node.setAttribute('stroke-dasharray', '8 6');
          node.setAttribute('x', a.x);
          node.setAttribute('y', a.y);
          node.setAttribute('width', a.w);
          node.setAttribute('height', a.h);
          if (a.rot) node.setAttribute('transform', 'rotate(' + a.rot + ' ' + cx + ' ' + cy + ')');
          layers[a.view].appendChild(node);
        }
      });
      preview.hidden = !any;
    }

    // ── Upload processing: white-background strip + DPI check ──
    function cornersWhite(p, w, h) {
      var pts = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
      var n = 0;
      for (var i = 0; i < 4; i++) {
        var o = pts[i];
        if (p[o + 3] === 0 || (p[o] >= 235 && p[o + 1] >= 235 && p[o + 2] >= 235)) n++;
      }
      return n >= 3;
    }
    function processFile(file, cb) {
      if (file.type === 'image/svg+xml' || /\.svg$/i.test(file.name)) {
        cb(URL.createObjectURL(file), null);
        return;
      }
      var src = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var W = img.naturalWidth, H = img.naturalHeight, MAX = 1600;
        var s = Math.min(1, MAX / Math.max(W, H));
        var cw = Math.max(1, Math.round(W * s)), ch = Math.max(1, Math.round(H * s));
        var c = document.createElement('canvas');
        c.width = cw;
        c.height = ch;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(img, 0, 0, cw, ch);
        try {
          var d = x.getImageData(0, 0, cw, ch), p = d.data;
          if (cornersWhite(p, cw, ch)) {
            for (var i = 0; i < p.length; i += 4) {
              var m = Math.min(p[i], p[i + 1], p[i + 2]);
              if (m >= 242) p[i + 3] = 0;
              else if (m >= 230) p[i + 3] = Math.min(p[i + 3], (242 - m) * 21);
            }
            x.putImageData(d, 0, 0);
          }
        } catch (err) {}
        URL.revokeObjectURL(src);
        c.toBlob(function (b) { cb(URL.createObjectURL(b || file), { w: W, h: H }); }, 'image/png');
      };
      img.onerror = function () {
        URL.revokeObjectURL(src);
        cb(URL.createObjectURL(file), null);
      };
      img.src = src;
    }
    function dpiWarning(dims, a, scale) {
      var s = scale || 1;
      var inW = a.in[0] * s, inH = a.in[1] * s;
      var boxA = inW / inH, imgA = dims.w / dims.h;
      var dpi = imgA > boxA ? dims.w / inW : dims.h / inH;
      if (dpi >= 150) return '';
      return 'Low resolution (~' + Math.round(dpi) + ' DPI at this print size) — may look blurry in print. A larger file is recommended.';
    }

    // Max-fit dimensions of the art inside its placement box (aspect locked).
    function fitDims(key) {
      var a = CFG.areas[key], art = window.RPZ.art[key];
      if (!art || !art.dims) return { w: a.w, h: a.h };
      var boxA = a.w / a.h, imgA = art.dims.w / art.dims.h;
      if (imgA > boxA) return { w: a.w, h: a.w / imgA };
      return { w: a.h * imgA, h: a.h };
    }

    // Actual printed dimensions in inches for the current art + size setting.
    function printDims(key) {
      var a = CFG.areas[key], art = window.RPZ.art[key];
      if (!art) return '';
      var s = art.scale || 1;
      var inW = a.in[0] * s, inH = a.in[1] * s;
      if (art.dims) {
        var boxA = inW / inH, imgA = art.dims.w / art.dims.h;
        if (imgA > boxA) inH = inW / imgA;
        else inW = inH * imgA;
      }
      return (Math.round(inW * 10) / 10) + '" × ' + (Math.round(inH * 10) / 10) + '"';
    }

    // Hidden line-item property inputs in the helper product form — the
    // section's customilyProps() harvests properties[...] inputs on add to
    // cart, so production sees artwork per placement with zero cart-JS work.
    function syncProps() {
      var form = document.getElementById('rpp-customily-form');
      if (!form) return;
      form.querySelectorAll('input[data-pz-prop]').forEach(function (i) { i.remove(); });
      Object.keys(window.RPZ.art).forEach(function (key) {
        var art = window.RPZ.art[key];
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.setAttribute('data-pz-prop', key);
        inp.name = 'properties[Artwork — ' + CFG.areas[key].label + ']';
        var val = art.remoteUrl || (art.file.name + ' (not uploaded — request file from customer)');
        var pd = printDims(key);
        if (pd) val += ' | Print size: ~' + pd;
        inp.value = val;
        form.appendChild(inp);
      });
    }

    // Design-preview thumbnail: snapshot the tinted mockup + art, upload via
    // the Worker, ride the URL on the cart as properties[Design Preview].
    var thumbTimer = null, lastThumbSig = '';
    function setThumbProp(url) {
      var form = document.getElementById('rpp-customily-form');
      if (!form) return;
      var inp = form.querySelector('input[data-pz-thumb]');
      if (!url) { if (inp) inp.remove(); return; }
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.setAttribute('data-pz-thumb', '1');
        inp.name = 'properties[Design Preview]';
        form.appendChild(inp);
      }
      inp.value = url;
    }
    function queueThumb() {
      if (!UPLOAD_ENDPOINT) return;
      clearTimeout(thumbTimer);
      thumbTimer = setTimeout(makeThumb, 2500);
    }
    function makeThumb() {
      var keys = Object.keys(window.RPZ.art);
      if (!keys.length) { lastThumbSig = ''; setThumbProp(null); return; }
      var fill = stage.style.getPropertyValue('--pz-fill') || '#d9d9d9';
      var sig = keys.sort().map(function (k) { return k + ':' + window.RPZ.art[k].url + '@' + (window.RPZ.art[k].scale || 1); }).join('|') + '|' + fill;
      if (sig === lastThumbSig) return;
      lastThumbSig = sig;
      // SVG drawn into a canvas can't fetch blob: URLs — inline art as data URLs
      Promise.all(keys.map(function (k) {
        return fetch(window.RPZ.art[k].url).then(function (r) { return r.blob(); }).then(function (b) {
          return new Promise(function (res) {
            var fr = new FileReader();
            fr.onload = function () { res([window.RPZ.art[k].url, fr.result]); };
            fr.readAsDataURL(b);
          });
        });
      })).then(function (pairs) {
        var clone = stage.cloneNode(true);
        clone.querySelectorAll('.pz__ui').forEach(function (el) { el.remove(); });
        var defs = document.createElementNS(SVGNS, 'defs');
        defs.innerHTML = document.querySelector('.pz__defs defs').innerHTML;
        clone.insertBefore(defs, clone.firstChild);
        clone.style.cssText = '--pz-fill:' + fill;
        var xml = new XMLSerializer().serializeToString(clone);
        pairs.forEach(function (p) { xml = xml.split(p[0]).join(p[1]); });
        var img = new Image();
        img.onload = function () {
          var c = document.createElement('canvas');
          c.width = 640;
          c.height = 640;
          var x = c.getContext('2d');
          x.fillStyle = '#ffffff';
          x.fillRect(0, 0, 640, 640);
          x.drawImage(img, 0, 0, 640, 640);
          c.toBlob(function (b) {
            if (!b) return;
            var fd = new FormData();
            fd.append('file', b, 'design-preview.png');
            fetch(UPLOAD_ENDPOINT, { method: 'POST', body: fd })
              .then(function (r) { return r.json(); })
              .then(function (j) { if (j.url) setThumbProp(j.url); })
              .catch(function () {});
          }, 'image/png');
        };
        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
      });
    }

    function uploadRemote(key, file) {
      if (!UPLOAD_ENDPOINT) return;
      var fd = new FormData();
      fd.append('file', file, file.name);
      fetch(UPLOAD_ENDPOINT, { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j.url && window.RPZ.art[key]) {
            window.RPZ.art[key].remoteUrl = j.url;
            syncProps();
          }
        })
        .catch(function () {});
    }

    function clearArt(cell, key) {
      var art = window.RPZ.art[key];
      if (art) {
        URL.revokeObjectURL(art.url);
        delete window.RPZ.art[key];
      }
      cell.querySelector('.pz__thumb-row').hidden = true;
      cell.querySelector('.pz__thumb').src = '';
      cell.querySelector('.pz__warn').hidden = true;
      cell.querySelector('input[type="file"]').value = '';
      var sizeBox = cell.querySelector('.pz__size');
      sizeBox.hidden = true;
      sizeBox.querySelector('.pz__size-val').textContent = '100%';
      syncProps();
      queueThumb();
    }
    function handleFile(cell, key, file) {
      if (!file) return;
      var a = CFG.areas[key];
      processFile(file, function (url, dims) {
        var old = window.RPZ.art[key];
        if (old) URL.revokeObjectURL(old.url);
        window.RPZ.art[key] = { url: url, file: file, dims: dims, remoteUrl: null, scale: 1 };
        syncProps();
        uploadRemote(key, file);
        cell.querySelector('.pz__thumb').src = url;
        cell.querySelector('.pz__thumb-row').hidden = false;
        var sizeBox = cell.querySelector('.pz__size');
        sizeBox.hidden = false;
        sizeBox.querySelector('.pz__size-val').textContent = '100%';
        var warn = cell.querySelector('.pz__warn');
        var msg = dims ? dpiWarning(dims, a, 1) : '';
        warn.textContent = msg;
        warn.hidden = !msg;
        redraw();
        setView(a.view);
        queueThumb();
      });
    }

    // ── Print size: locked-aspect diagonal drag on the preview handle ──
    var drag = null;
    function svgPoint(e) {
      var pt = stage.createSVGPoint();
      pt.x = e.clientX; pt.y = e.clientY;
      return pt.matrixTransform(stage.getScreenCTM().inverse());
    }
    function applyScale(key, scale) {
      var art = window.RPZ.art[key];
      if (!art) return;
      art.scale = Math.min(1, Math.max(0.25, scale));
      var cell = root.querySelector('.pz__cell[data-key="' + key + '"]');
      if (cell) {
        cell.querySelector('.pz__size-val').textContent = Math.round(art.scale * 100) + '%';
        var warn = cell.querySelector('.pz__warn');
        var msg = art.dims ? dpiWarning(art.dims, CFG.areas[key], art.scale) : '';
        warn.textContent = msg;
        warn.hidden = !msg;
      }
      redraw();
    }
    stage.addEventListener('pointerdown', function (e) {
      var h = e.target.closest('.pz__handle');
      if (!h) return;
      e.preventDefault();
      var key = h.getAttribute('data-key');
      var a = CFG.areas[key], fit = fitDims(key);
      drag = {
        key: key,
        cx: a.x + a.w / 2,
        cy: a.y + a.h / 2,
        baseHalfDiag: Math.sqrt(fit.w * fit.w + fit.h * fit.h) / 2
      };
      stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var p = svgPoint(e);
      // Distance from placement centre is rotation-invariant, so sleeves work too.
      var dist = Math.sqrt(Math.pow(p.x - drag.cx, 2) + Math.pow(p.y - drag.cy, 2));
      applyScale(drag.key, dist / drag.baseHalfDiag);
    });
    function endDrag() {
      if (!drag) return;
      drag = null;
      syncProps();
      queueThumb();
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    // ── Tile interactions ──
    root.addEventListener('change', function (e) {
      if (e.target.matches('input[type="file"]')) {
        var fcell = e.target.closest('.pz__cell');
        handleFile(fcell, fcell.dataset.key, e.target.files[0]);
        return;
      }
      var cb = e.target.closest('input[type="checkbox"]');
      if (!cb) return;
      var cell = cb.closest('.pz__cell'), key = cell.dataset.key;
      cell.classList.toggle('is-on', cb.checked);
      cell.querySelector('.pz__panel').hidden = !cb.checked;
      if (!cb.checked) clearArt(cell, key);
      redraw();
      if (cb.checked) setView(CFG.areas[key].view);
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('.pz__upload-btn')) {
        e.target.closest('.pz__panel').querySelector('input[type="file"]').click();
      } else if (e.target.closest('.pz__remove')) {
        var cell = e.target.closest('.pz__cell');
        clearArt(cell, cell.dataset.key);
        redraw();
      }
    });

    // ── Clicking a real product thumbnail resets the personalizer ──
    function resetAll() {
      root.querySelectorAll('.pz__cell').forEach(function (cell) {
        var cb = cell.querySelector('input[type="checkbox"]');
        if (cb.checked) {
          cb.checked = false;
          cell.classList.remove('is-on');
          cell.querySelector('.pz__panel').hidden = true;
          clearArt(cell, cell.dataset.key);
        }
      });
      redraw();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('.rpp__thumb') && !preview.hidden) resetAll();
    });

    // ── Mobile: float the preview as a mini-card when the gallery scrolls
    //    out of view (only while placements are active) ──
    var mobileMQ = window.matchMedia('(max-width: 899px)');
    var galleryBox = document.querySelector('.rpp__gallery') || preview.parentElement;
    var galleryVisible = true;
    function syncFloat() {
      preview.classList.toggle('is-float', mobileMQ.matches && !galleryVisible && !preview.hidden);
    }
    if ('IntersectionObserver' in window && galleryBox) {
      new IntersectionObserver(function (entries) {
        galleryVisible = entries[0].isIntersecting;
        syncFloat();
      }, { threshold: 0.05 }).observe(galleryBox);
    }
    mobileMQ.addEventListener ? mobileMQ.addEventListener('change', syncFloat) : mobileMQ.addListener(syncFloat);
    var origRedraw = redraw;
    redraw = function () { origRedraw(); syncFloat(); };

    // ── Garment tint from selected color (Step 1 buttons) ──
    function applyColor(name) {
      stage.style.setProperty('--pz-fill', hexMap[name] || '#d9d9d9');
      queueThumb();
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.rbo__color-btn');
      if (b) applyColor(b.dataset.color);
    });
    var active = document.querySelector('.rbo__color-btn.is-active');
    if (active) applyColor(active.dataset.color);

    setView('front');
  })();
  } catch(e) { console.error(e); }
})();

})();
